import appTypeConfigFunc from 'apptype-config'

export default async function getMenuData() {
  const appTypeConfig = appTypeConfigFunc()
  const { adminMenuList, menuList } = appTypeConfig.menu()

  return { adminMenuList, menuList }
}
